import createReducer from 'shared/utils/createReducer';

import { LOGIN } from 'modules/auth/actions/login';
import { LOGOUT } from 'modules/auth/actions/logout';

import {
  SET_TEXT_SEARCH,
  SET_SORT_FIELD,
  SET_FILTER_BY_LAST_CONVERSATION_STATUS,
  SET_FILTER_BY_CLOSE_REASON,
  SET_FILTER_BY_SCHEDULE_TYPE,
  SET_FILTER_BY_ASSIGNEE,
  SET_FILTER_BY_SERVICES,
  SET_FILTER_BY_DATES,
  SET_FILTER_BY_GROUPED_APPOINTMENTS,
  SET_FILTER_BY_CONVERSATION_TYPE,
  SET_DATERANGE_TYPE,
  RESET_ALL_ACCORDEON_FILTERS,
  RESET_SORT,
  } from 'modules/queues/Archive/actions/archiveAppointmentsFilters';

import { SORT_FIELDS_TYPES, DATERANGE_TYPES } from 'modules/queues/constants/appointmentsFilters';
import { APPOINTMENT } from 'modules/common/constants/consultationTypes';

const accordeonFilters = {
  services: [],
  lastConversationStatuses: [],
  scheduleTypes: [],
  closeReasons: [],
  isGroupAppointment: [],
  dateRange: {
    type: DATERANGE_TYPES.SCHEDULED,
    startDate: null,
    endDate: null,
  },
  consultationTypes: [APPOINTMENT],
  conversationTypes: [],
};

const defaultFilters = {
  ...accordeonFilters,
  assignees: [],
};

const defaultState = {
  textSearch: '',
  activeSortField: { field: SORT_FIELDS_TYPES.CLOSED_TIME, direction: 'DESC' },
  ...defaultFilters,
};

export default createReducer(defaultState, {
  [SET_TEXT_SEARCH]: (state, { payload: { textSearch } }) => ({
    ...state,
    ...defaultFilters,
    textSearch,
  }),

  [SET_SORT_FIELD]: (state, { payload: { activeSortField } }) => ({
    ...state,
    activeSortField,
  }),

  [SET_FILTER_BY_LAST_CONVERSATION_STATUS]: (state, { payload: { lastConversationStatuses } }) => ({
    ...state,
    lastConversationStatuses,
    textSearch: defaultState.textSearch,
  }),

  [SET_FILTER_BY_CLOSE_REASON]: (state, { payload: { closeReasons } }) => ({
    ...state,
    closeReasons,
    textSearch: defaultState.textSearch,
  }),

  [SET_FILTER_BY_ASSIGNEE]: (state, { payload: { assignees } }) => ({
    ...state,
    assignees,
    textSearch: defaultState.textSearch,
  }),

  [SET_FILTER_BY_SERVICES]: (state, { payload: { services } }) => ({
    ...state,
    services,
    textSearch: defaultState.textSearch,
  }),

  [SET_FILTER_BY_DATES]: (state, { payload: { dateRange } }) => ({
    ...state,
    dateRange: {
      ...state.dateRange,
      ...dateRange,
    },
    textSearch: defaultState.textSearch,
  }),

  [SET_FILTER_BY_SCHEDULE_TYPE]: (state, { payload: { scheduleTypes } }) => ({
    ...state,
    scheduleTypes,
    textSearch: defaultState.textSearch,
  }),

  [SET_FILTER_BY_GROUPED_APPOINTMENTS]: (state, { payload: { isGroupAppointment } }) => ({
    ...state,
    isGroupAppointment,
    textSearch: defaultState.textSearch,
  }),

  [SET_FILTER_BY_CONVERSATION_TYPE]: (state, { payload: { conversationTypes } }) => ({
    ...state,
    conversationTypes,
    textSearch: defaultState.textSearch,
  }),

  [SET_DATERANGE_TYPE]: (state, { payload: { type } }) => ({
    ...state,
    dateRange: {
      ...state.dateRange,
      type,
    },
    textSearch: defaultState.textSearch,
  }),

  [RESET_ALL_ACCORDEON_FILTERS]: (state) => ({
    ...state,
    ...accordeonFilters,
    textSearch: defaultState.textSearch,
  }),

  [RESET_SORT]: (state) => ({
    ...state,
    activeSortField: defaultState.activeSortField,
  }),

  [LOGIN.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
